import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import React, { Key, useEffect, useState } from 'react';
import { Button, Col, Form, FormInstance, Row, Spin, Tooltip, Transfer, TransferProps, Typography } from "antd";
import FormItemDropdown from "../../../../../components/form-dropdown/FormItemDropdown";
import { getListStudentAddEnrolled } from "../../../../../service/course-construct";
import './index.scss'


type CreateClassProps = {
  formProps: FormInstance,
  dataOptions?: any,
  classId?: number,
  checkIsFormEdit?: any,
  isOpened?: any,
  resetPermissions?: any,
  isOpenDrawer?: boolean,
  listStudents?: any[],
  setIsDirty: (value: boolean) => void;
  setDeletedStudents: (value: number[]) => void;
}

interface RecordType {
  key: string;
  title: string;
  description: string;
  chosen: boolean;
  username?: string
}


const CreateStudent = ({
  formProps, 
  dataOptions,
  isOpened,
  classId,
  isOpenDrawer,
  checkIsFormEdit,
  listStudents,
  setIsDirty,
  setDeletedStudents,
}: CreateClassProps) => {
  const { t } = useTranslation();
  const [targetKeys, setTargetKeys] = useState<Key[]>([]);
  const [selectedKeys, setSelectedKeys] = useState<Key[]>([]);
  const [dataTransfer, setDataTransfer] = useState<RecordType[]>([])
  const [valueSearchLeft, setValueSearchLeft] = useState('');
  const [valueSearchRight, setValueSearchRight] = useState('');
  const [valueDir, setValueDir] = useState('');
  const [pageSize, setPageSize] = useState(30);
  const [dataStudents, setDataStudents] = useState<any[]>([]);
  const [selectedStudents, setSelectedStudents] = useState<any[]>([])
  const [dataSelect, setDataSelect] = useState<any[]>([]);
  const [studentsInEnrollClass, setStudentsInEnrollClass] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dataFilter, setDataFilter] = useState<any>({
    universityIds: [],
    industryIds: []
  });

  const isDirty = formProps.isFieldsTouched(true);
  const [form] = Form.useForm()

  const newDataUniversity = dataOptions.dataUniversity && dataOptions.dataUniversity.map((data: {
    id: any;
    name: any;
  }) => ({
    id: data.id,
    label: data.name
  }))

  const newDataIndustry = dataOptions.dataIndustry && dataOptions.dataIndustry.map((data: {
    id: any;
    name: any;
  }) => ({
    id: data.id,
    label: data.name
  }))

  const fetchData = () => {
    setIsLoading(true);
    const dataReqFilter = {
      enrollClassId: classId,
      universityIds: dataFilter.universityIds,
      industryIds: dataFilter.industryIds,
      keyword: valueSearchLeft.length > 0 && valueDir === 'left' ? valueSearchLeft : valueSearchRight.length > 0 && valueDir === 'right' ? valueSearchRight : ""
    }
    getListStudentAddEnrolled(dataReqFilter).then(res => {
      const { data } = res.data;
      setPageSize(data.numberOfElements);
      setDataStudents([...data?.content]);
      setIsLoading(false);
    }).finally(() => setIsLoading(false));
  }
  
  function mergeArraysDistinctByKey(arr1: any[], arr2:any[]) {
    const combined = [...arr1, ...arr2];
    const keySet = new Set();

    return combined.filter(item => {
      if (keySet.has(item['id'])) {
        return false;
      }
      keySet.add(item['id']);
      return true;
    });
  }

  const getNewData = () => {
    if (dataStudents) {
      const dataSelectedStudents = selectedStudents.map((item) => ({
        id: item.studentId,
        name: item.studentName,
        username: item.email
      }));

      const newData: RecordType[] = mergeArraysDistinctByKey(dataStudents, dataSelectedStudents).map((student: any, i: number) => {
        return {
          key: student.id.toString(),
          title: student.name,
          description: student.name,
          chosen: true,
          username: student.username,
        }
      });

      const sortedNewData = [...newData].sort((a, b) => Number(a.key) - Number(b.key));
      setDataTransfer(sortedNewData);
      
      const targetKey = dataSelectedStudents.map((item: any, i) => String(item.id));
      setTargetKeys([...targetKey]);

      const studentIds = dataSelectedStudents.map((item: any) => item.id);
      setStudentsInEnrollClass(studentIds);
    }
  }

  useEffect(() => {
    if(listStudents) {
      setSelectedStudents(listStudents);
    }
  }, [listStudents]);

  useEffect(() => {
    if (!isOpenDrawer) {
      setTargetKeys([]);
      formProps.resetFields();
      form.resetFields();
      setDataFilter({
        universityIds: [],
        industryIds: []
      });
    } else {
      fetchData();
    }
  }, [classId, isOpenDrawer, dataFilter, valueSearchLeft, valueSearchRight]);

  useEffect(() => {
    setPageSize(30);
  }, [isOpened]);

  useEffect(() => {
    getNewData();
  }, [dataStudents, selectedStudents, listStudents]);

  const handleSearch: TransferProps['onSearch'] = (dir, value) => {
    if (dir === 'left') {
      setValueSearchLeft(value.trim());
      setValueDir(dir);
    } else {
      setValueSearchRight(value.trim());
      setValueDir(dir);
    }
  };

  const loadMore = () => {
    setPageSize(pageSize + 10)
  }

  const filterOption = (inputValue: string, option: RecordType) => {
    return option.description.toLowerCase().indexOf(inputValue.toLowerCase().trim()) > -1;
  }

  const handleChange: TransferProps['onChange'] = (newTargetKeys, direction) => {
    setTargetKeys(newTargetKeys);
    const idSet = new Set(newTargetKeys.map(item => Number(item)));
    const deletedStudents = studentsInEnrollClass.filter(item => !idSet.has(item));
    setDeletedStudents(deletedStudents);

    if (direction === 'right') {
      
    }
    if (direction === 'left') {
    }
  };

  const renderItem = (item: RecordType) => {
    const customLabel = (
      <Tooltip placement="top" title={`${item.title} (${item?.username})`} >
        <span className="custom-item">
          {item.title} ({item?.username})
        </span>
      </Tooltip>
    );

    return {
      label: customLabel,
      value: item.title,
    };
  };

  const renderFooter: TransferProps['footer'] = (_, info) => {
    if (info?.direction === 'left') {
      return (
        <Button size="small" style={{ float: 'left', margin: 5 }} onClick={loadMore}>{t("Tải thêm", "Tải thêm")}</Button>
      );
    }
  };

  const handleFilter = (values: any) => {
    setDataFilter({
      ...dataFilter,
      universityIds: values.universityIds,
      industryIds: values.industryIds,
    });
  }

  useEffect(() => {
    setIsDirty(isDirty);
  }, [isDirty])

  return (
    <>
      <Form form={form} onFinish={handleFilter} className="form-create--student">
        <Row gutter={16}>
          <Col className="col-table-create" span={24}>
            <Form.Item
              name="universityIds"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              labelAlign="left"
              label={t("Trường", "Trường")}
            >
              <FormItemDropdown options={newDataUniversity} modeDropdown="multiple" allowClear placeholder={t("Chọn trường", "Chọn trường")} />
            </Form.Item>
          </Col>
          <Col className="col-table-create" span={24}>
            <Form.Item
              name="industryIds"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              labelAlign="left"
              label={t("Chuyên ngành", "Chuyên ngành")}
            >
              <FormItemDropdown options={newDataIndustry} modeDropdown="multiple" allowClear placeholder={t("Chọn chuyên ngành", "Chọn chuyên ngành")} />
            </Form.Item>
          </Col>
          {/*TODO*/}
          {/*<Col className="col-table-create" span={24}>
            <Form.Item
              name="numberStudent"
              labelCol={{span: 6}}
              wrapperCol={{span: 18}}
              labelAlign="left"
              label={t("Khóa học tiên quyết", "Khóa học tiên quyết")}
            >
              <FormItemDropdown placeholder={t("Chọn khóa học", "Chọn khóa học")}/>
            </Form.Item>
          </Col>*/}
        </Row>
        <div className="group-button">
          <Button className="btn btn-primary" onClick={() => form.submit()}>
            <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
          </Button>
        </div>
      </Form>
      <Form
        form={formProps}
        name="createStudent"
        className="create-student--enroll"
      >
        <div className="student-transfer">
          <Spin spinning={isLoading}>
            <Form.Item name="listStudent">
              <Transfer listStyle={{ width: "47%", height: 550 }}
                dataSource={dataTransfer}
                showSearch
                selectAllLabels={[
                  ({ selectedCount, totalCount }) => (
                    <span>
                      {totalCount} {t("học viên", "học viên")}
                    </span>
                  )
                  , ({ selectedCount, totalCount }) => (
                    <span>
                      {totalCount} {t("học viên", "học viên")}
                    </span>
                  )
                ]}
                footer={renderFooter}
                selectedKeys={selectedKeys as any}
                locale={{ searchPlaceholder: t("Tìm học viên", "Tìm học viên") }}
                filterOption={filterOption}
                onSearch={handleSearch}
                titles={[t("Tất cả học viên", "Tất cả học viên"), t("Học viên đã lựa chọn", "Học viên đã lựa chọn")]}
                onChange={handleChange}
                onSelectChange={(sourceSelectedKeys: Key[], targetSelectedKeys: Key[]) => {
                  setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys])
                  const res = dataStudents.filter((item: any) => {
                    return sourceSelectedKeys.indexOf(item.id.toString()) >= 0
                  })
                  setDataSelect(res)
                }}
                render={renderItem}
                targetKeys={targetKeys as string[]}
              />
            </Form.Item>
          </Spin>
        </div>
      </Form>
    </>
  );
};

export default CreateStudent;
